import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Root } from './components/Root';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
